
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 4c6.616 0 12 5.385 12 12s-5.385 12-12 12S4 22.615 4 16h2c0 5.535 4.465 10 10 10s10-4.465 10-10S21.535 6 16 6c-3.702 0-6.897 2.02-8.625 5H11v2H4V6h2v3.344A11.987 11.987 0 0116 4zm-1 4h2v7h5v2h-7V8z"}})])
          )
        }
      }
    